import {TOGGLE_EMOJI_PANEL} from '../actions';

export default function emojiPane(state = false, action) {
  switch (action.type) {
    case TOGGLE_EMOJI_PANEL:
      return action.isOpen;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/emojiPanel.js